<script setup>
import { ref, computed, watch } from 'vue';
import { useQuasar } from 'quasar';
const $q = useQuasar();
const isLargeScreen = computed(() => $q.screen.gt.xs);

const darkMode = ref($q.dark.isActive);

watch(() => $q.dark.isActive, (newVal) => {
    darkMode.value = newVal;
})


useHead({
    title: 'Our Team',
    meta: [
        { name: 'description', content: 'OnSight Optical Staff' }
    ]
})
</script>


<template>
    <div class="text-center">
        <h3 :class="darkMode ? 'text-grey-5' : 'text-brand'">Our Team</h3>
    </div>
    <div>
        <div class="q-mx-lg q-mb-lg q-col-gutter-lg row justify-center">
            <div :class="['col-12 col-md-6', darkMode ? 'bg-transparent text-grey-5' : 'bg-white text-brand']">
                <div class="text-h5 text-left"><strong>Mike Shane</strong></div>
                <div class="text-h6 text-left">President</div>
                <br>
                <div>
                    <p style="font-size: 20px; text-align: left;">
                        President, Chief Financial Officer and founder of OnSight Optical brings to the organization a
                        profound understanding of business operations, financial management and construction knowledge.
                        Specific to Ophthalmology, Mr. Shane has worked in the administration of practice and the
                        development of surgery centers. He is an active participant in an elite group of
                        ophthalmologists, which meet bi-annually. Prior to founding OnSight Optical in 1995, he was a
                        successful developer and builder throughout Florida. Mr. Shane served as a Senior Analyst and
                        bank officer for banks in New York and Florida. Mr. Shane received a B.S. in Finance/Accounting
                        from Indiana University. When Mike is not in the office, you should look for him around town
                        running, biking or swimming. As of November 2015, Mike became a real Ironman as he completed a
                        full Ironman race in Pensacola, FL.
                    </p>
                </div>
            </div>

            <div :class="['col-12 col-md-6', darkMode ? 'bg-transparent text-grey-5' : 'bg-white text-brand']">
                <div class="text-h5 text-left"><strong>Linda Willett</strong></div>
                <div class="text-h6 text-left">Vice President</div>
                <br>
                <div>
                    <p style="font-size: 20px; text-align: left;">
                        Vice President of Operations, joined OnSight Optical in May of 2000. She works with both
                        management and individual ophthalmology practices in the development of programs and practices,
                        to enhance business operations. Mrs. Willett brings over 20 years of experience in a healthcare
                        environment in various roles such as Human Resources, Administration, Compensation, Risk
                        Management and Training and Development. Prior to joining OnSight Optical, Mrs. Willett worked
                        in the eye care industry as Supervisor of Employment, Training and Risk Management Departments.
                    </p>
                </div>
            </div>

            <div :class="['col-12 col-md-6', darkMode ? 'bg-transparent text-grey-5' : 'bg-white text-brand']">
                <div class="text-h5 text-left"><strong>Brian Lemnus</strong></div>
                <div class="text-h6 text-left">Lab Manager</div>
                <br>
                <div>
                    <p style="font-size: 20px; text-align: left;">
                        Brian Lemnus is a highly skilled Lab Manager, who has been an integral part of OnSight Optical
                        since 2013. He brings with him extensive management experience from working at two large retail
                        opticals, making him an expert in managing labs.As the Lab Manager at OnSight Optical, Brian
                        oversees the staff, workflow, and maintenance of all the machines used to fabricate lenses. He
                        has an impeccable attention to detail and is committed to ensuring that every customer receives
                        a high-quality product and exceptional service.Brian's contributions to OnSight Optical have
                        been invaluable in maintaining its reputation as a leading provider of optical solutions. His
                        expertise in managing labs and dedication to quality have undoubtedly helped the company succeed
                        in delivering outstanding results to its customers.
                    </p>
                </div>
            </div>

            <div :class="['col-12 col-md-6', darkMode ? 'bg-transparent text-grey-5' : 'bg-white text-brand']">
                <div class="text-h5 text-left"><strong>James Goebel</strong></div>
                <div class="text-h6 text-left">Managed Care Operations Manager</div>
                <br>
                <div>
                    <p style="font-size: 20px; text-align: left;">
                        James Goebel, a Licensed Optician in the state of Florida since 2016 with both ABO and NCLE
                        certifications, has been a vital part of the OnSight team since 2006. Initially joining as a lab
                        technician, James has since taken on the role of Managed Care Operations Manager. His eye for
                        innovation and extensive knowledge of the industry enable him to identify the latest trends and
                        technologies that benefit our clients. As a result, James has played a significant role in
                        maintaining OnSight's reputation for providing cutting-edge eye care solutions. His dedication
                        to excellence and commitment to client satisfaction make him an integral part of our
                        organization.
                    </p>
                </div>
            </div>

            <div :class="['col-12 col-md-6', darkMode ? 'bg-transparent text-grey-5' : 'bg-white text-brand']">
                <div class="text-h5 text-left"><strong>Jennifer Lemnus</strong></div>
                <div class="text-h6 text-left">Managed Care Coordinator and Operations Manager</div>
                <br>
                <div>
                    <p style="font-size: 20px; text-align: left;">
                        Jennifer Lemnus holds the position of Managed Care Coordinator and Operations Manager at OnSight
                        Optical. In this capacity, she is responsible for strategic guidance and leadership in areas
                        such as vision programs, plans, billing, and managing accounts receivables for all OnSight
                        Optical locations. Additionally, Jennifer collaborates with the organization, physicians,
                        administrators, and opticians to suggest vision eye care service programs and stay current with
                        industry trends.Originally from Florida, Jennifer has over 30 years of experience in the optical
                        field, with expertise in operations, glasses lab manufacturing, management, training, and vision
                        plans. Her professional background includes management roles in a large retail optical company,
                        a multi-office ophthalmology practice, a contracted practice at MacDill Air Force Base, and
                        assistance in vision plan billing for ophthalmology.
                    </p>
                </div>
            </div>

            <div :class="['col-12 col-md-6', darkMode ? 'bg-transparent text-grey-5' : 'bg-white text-brand']">
                <div class="text-h5 text-left"><strong>Greg Johnson</strong></div>
                <div class="text-h6 text-left">System Engineer</div>
                <br>
                <div>
                    <p style="font-size: 20px; text-align: left;">
                        Since joining OnSight Optical in 2015, Greg Johnson has been a key contributor to the company's
                        success as a systems engineer. With a Bachelor's degree in Physics from the University of South
                        Florida, Greg's technical knowledge and problem-solving abilities have been essential in
                        delivering innovative solutions to complex challenges. He is highly regarded for his expertise
                        in engineering and his commitment to continuous learning, which enable him to keep pace with
                        emerging technologies and offer valuable insights to the team.
                    </p>
                </div>
            </div>

            <div :class="['col-12 col-md-6', darkMode ? 'bg-transparent text-grey-5' : 'bg-white text-brand']">
                <div class="text-h5 text-left"><strong>Becca Shane</strong></div>
                <div class="text-h6 text-left">Operations Assistant</div>
                <br>
                <div>
                    <p style="font-size: 20px; text-align: left;">
                        Becca Shane is the Operations Assistant who started at OnSight Optical in July 2021. Some of her
                        responsibilities include assisting customer service, managing frame inventory, processing frame
                        credit returns, and providing FlexSys training. Becca holds a degree in Hospitality Management
                        from the world renowned Rosen College of Hospitality Management at the University of Central
                        Florida. She has an extensive background beginning with Universal Studios, Orlando and in the
                        luxury hospitality industry, having worked at prestigious establishments such as The Lodge and
                        Spa at Cordillera, The Ritz-Carlton Bachelor Gulch, The Ritz-Carlton Washington D.C., The
                        Ritz-Carlton New Orleans, and The Ritz-Carlton Sarasota.
                    </p>
                </div>
            </div>

            <div :class="['col-12 col-md-6', darkMode ? 'bg-transparent text-grey-5' : 'bg-white text-brand']">
                <div class="text-h5 text-left"><strong>Scott Miller</strong></div>
                <br>
                <div>
                    <p style="font-size: 20px; text-align: left;">
                        Scott Miller, a seasoned professional with 28 years of experience in the optical industry, has
                        served as a General Manager for large chains and worked as an Optometry Tech. He holds an
                        Associate's degree in Business from Salem University, which has refined his managerial and
                        strategic skills. In his current role, Scott leads our Customer Service team, ensuring
                        exceptional care and support. His extensive background and dedication to client satisfaction
                        make Scott instrumental in fostering a positive experience for everyone who interacts with our
                        company.
                    </p>
                </div>
            </div>

        </div>
    </div>
</template>
